import type { IconSvgObject } from './types';

const EdgeStyleIcon: IconSvgObject = [
  ["path", { d: "M3 6H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 10H10.5M13.5 10H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 14H7M10 14H14M17 14H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 18H5M8.5 18H10.5M13.5 18H15.5M19 18H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }]
];

export default EdgeStyleIcon;
